import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _14df2b56 = () => import('..\\pages\\choose.vue' /* webpackChunkName: "pages_choose" */).then(m => m.default || m)
const _7e67871c = () => import('..\\pages\\customer.vue' /* webpackChunkName: "pages_customer" */).then(m => m.default || m)
const _516dd114 = () => import('..\\pages\\customerNew.vue' /* webpackChunkName: "pages_customerNew" */).then(m => m.default || m)
const _0da88100 = () => import('..\\pages\\order.vue' /* webpackChunkName: "pages_order" */).then(m => m.default || m)
const _e49aba84 = () => import('..\\pages\\orderList.vue' /* webpackChunkName: "pages_orderList" */).then(m => m.default || m)
const _16447ef8 = () => import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'hash',
    base: './',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/choose",
			component: _14df2b56,
			name: "choose"
		},
		{
			path: "/customer",
			component: _7e67871c,
			name: "customer"
		},
		{
			path: "/customerNew",
			component: _516dd114,
			name: "customerNew"
		},
		{
			path: "/order",
			component: _0da88100,
			name: "order"
		},
		{
			path: "/orderList",
			component: _e49aba84,
			name: "orderList"
		},
		{
			path: "/",
			component: _16447ef8,
			name: "index"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js